import { useCreateClinic } from '@/services/mutations/clinic';
import { ClinicForm } from './components/ClinicForm';
import { useNavigate } from 'react-router-dom';
import { PageTitle } from '@/components';

const CreateClinic = () => {
	const navigate = useNavigate();

	const onBack = () => navigate('/admin/clinicas');

	const { mutate, isPending } = useCreateClinic(() => onBack());

	const onSubmit = (data: Clinics.Create | Partial<Clinics.Create>) => {
		if (!data.clinic) return;
		mutate(data as Clinics.Create);
	};

	return (
		<section className="space-y-4 px-4 py-8">
			<PageTitle
				text="Clínicas"
				// type='clinic'
			/>
			<ClinicForm
				formTitle="Criar nova clínica"
				onBack={() => onBack()}
				onSubmit={onSubmit}
				isSubmitting={isPending}
			/>
		</section>
	);
};

export { CreateClinic };
